(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["as-product-enquiry-context"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const panel = document.querySelector('[data-product-enquiry]');
      if (!panel || panel.dataset.ready) return;
      const params = new URLSearchParams(window.location.search);
      const title = params.get('as_product');
      const path = params.get('as_product_path');
      if (!title || title.length > 300 || !path || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/?#\\]+$/i.test(path)) return;
      const url = new URL(path, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const link = panel.querySelector('[data-enquiry-product-link]');
      const include = panel.querySelector('[data-enquiry-product-include]');
      const field = panel.querySelector('[data-enquiry-product-value]');
      link.textContent = title;
      link.href = url.href;
      field.value = title + '\n' + url.href;
      const sync = () => { field.disabled = !include.checked; };
      include.addEventListener('change', sync);
      window.addEventListener('pageshow', sync);
      panel.closest('form').addEventListener('reset', () => setTimeout(sync, 0));
      sync();
      panel.hidden = false;
      panel.dataset.ready = 'true';
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["as-selection-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    function update(wrapper) {
      const panel = wrapper.closest('.product_section')?.querySelector('[data-selection-summary]');
      if (!panel) return;
      try {
        const product = JSON.parse(wrapper.dataset.product);
        if (String(product.id) !== panel.dataset.productId) return;
        const id = wrapper.querySelector('select[name="id"], input[name="id"]')?.value;
        const variant = product.variants.find(item => String(item.id) === id);
        const option = panel.querySelector('[data-selected-option]');
        if (option) option.textContent = variant ? variant.title : panel.dataset.chooseLabel;
        panel.querySelector('[data-selection-availability]').textContent = variant ? (variant.available ? panel.dataset.availableLabel : panel.dataset.unavailableLabel) : panel.dataset.chooseLabel;
      } catch {
        const option = panel.querySelector('[data-selected-option]');
        if (option) option.textContent = panel.dataset.chooseLabel;
        panel.querySelector('[data-selection-availability]').textContent = panel.dataset.chooseLabel;
      }
    }
    document.addEventListener('change', event => {
      const wrapper = event.target instanceof Element && event.target.closest('[data-product-form]');
      if (wrapper) requestAnimationFrame(() => update(wrapper));
    });
    window.addEventListener('pageshow', () => document.querySelectorAll('[data-product-form]').forEach(update));
  })();
  } catch(e) { console.error(e); }
})();

})();
